import { primaryColor, warningColor } from '../assets/jss/material-dashboard-pro-react';

const vulcanMuiTheme = {
    palette: {
        primary: {
            main: primaryColor, //'#28367a'
            dark: '#1d2549',
            light: '#007cbd',
            contrastText: '#fff',
        },
        secondary: {
            main: warningColor, //'#ffcc00'
            dark: '#e56d29',
            light: '#ffd750',
            contrastText: '#1d2549',
        },
    },
};

export { vulcanMuiTheme };
